import {ImageWidgetModalComponent} from './image-widget-modal/image-widget-modal.component';
import {YoutubeWidgetModalComponent} from './youtube-widget-modal/youtube-widget-modal.component';
import {ComponentType} from '@angular/cdk/portal';
import { SoundcloudWidgetModalComponent } from './soundcloud-widget-modal/soundcloud-widget-modal.component';
import { VimeoWidgetModalComponent } from './vimeo-widget-modal/vimeo-widget-modal.component';
import { SpotifyWidgetModalComponent } from './spotify-widget-modal/spotify-widget-modal.component';
import { TwitchWidgetModalComponent } from './twitch-widget-modal/twitch-widget-modal.component';
import { TiktokWidgetModalComponent } from './tiktok-widget-modal/tiktok-widget-modal.component';
import { TextWidgetModalComponent } from './text-widget-modal/text-widget-modal.component';
import { SocialsWidgetModalComponent } from './socials-widget-modal/socials-widget-modal.component';

export const WIDGET_LIST: {
    type: string;
    name?: string;
    description: string;
    image?: string;
    component: ComponentType<any>;
}[] = [
    {
        type: 'image',
        image: 'image.png',
        description:
            'Upload an image and optionally add a link it will redirect to when clicked.',
        component: ImageWidgetModalComponent,
    },
    {
        type: 'text',
        image: 'text.png',
        description:
            'Add title and optional description. Can be used as a header for the whole biolink or a group of multiple widgets.',
        component: TextWidgetModalComponent,
    },
    {
        type: 'socials',
        name: 'Social Links',
        image: 'socials.png',
        description:
            'Add your socials links to display them as icon buttons.',
        component: SocialsWidgetModalComponent,
    },
    {
        name: 'Youtube Video',
        type: 'youtubeEmbed',
        image: 'youtube.png',
        description:
            'Paste a YouTube video URL to show it as a video embed in your profile.',
        component: YoutubeWidgetModalComponent
    },
    {
        name: 'Soundcloud Video',
        type: 'soundcloudEmbed',
        image: 'soundcloud.png',
        description:
            'Paste a SoundCloud URL to show it as a playable song in your profile.',
        component: SoundcloudWidgetModalComponent
    },
    {
        name: 'Vimeo Video',
        type: 'vimeoEmbed',
        image: 'vimeo.jpeg',
        description:
            'Paste a vimeo URL to show it as a video embed in your profile.',
        component: VimeoWidgetModalComponent
    },
    {
        name: 'Spotify Embed',
        type: 'spotifyEmbed',
        image: 'spotify.png',
        description:
            'Paste a spotify song, album, artist, playlist, podcast or episode url to show it as an embed in your profile.',
        component: SpotifyWidgetModalComponent
    },
    {
        name: 'Twitch Embed',
        type: 'twitchEmbed',
        image: 'twitch.svg',
        description:
            'Paste twitch profile or clip url to show it as an embed in your profile.',
        component: TwitchWidgetModalComponent,
    },
    {
        name: 'TikTok Embed',
        type: 'tiktokEmbed',
        image: 'tiktok.png',
        description:
            'Paste TikTok video url to show it as an embed in your profile.',
        component: TiktokWidgetModalComponent,
    },
];
